import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import ComingSoon from '../../../../commonComponent/ComingSoon';

function PayrollManagement() {
  const navigate = useNavigate(); // Initialize useNavigate for routing

  return (
    <div>
      <div className=" p-6 bg-gray-100">
        <header className="flex justify-between items-center mb-3 bg-white p-3">
          <h1 className="text-black text-xl font-bold ml-2">Human Resource Management (HRM)</h1>
          <div className="flex space-x-6">
            <button
              onClick={() => navigate('/dashboard/core-modules/hrm/staff-scheduling')}
              className="btn"
            >
              Staff Scheduling and Time Management
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/hrm/payroll-management')}
              className="btn text-black font-bold"
            >
              Payroll Management
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/hrm/employee-training')}
              className="btn"
            >
              Employee Training and Certification
            </button>
          </div>
        </header>
        <ComingSoon />
      </div>
    </div>
  );
}

export default PayrollManagement;
